import React from 'react';
import { Button } from '@shared/ui/button';
import { OrderSummary, SafeAndSecure } from './SharedCards';
import { ShieldAlert, CreditCard as CreditCardIcon, Landmark, Smartphone, Info } from 'lucide-react';

export const PaymentDetailsStep = ({ onNext, onPrevious, allStepData }: any) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* Left Pane */}
      <div className="lg:col-span-2">
        <div className="bg-white rounded-xl border p-6 h-full flex flex-col">
          <h3 className="text-gray-900 font-semibold text-lg mb-4">Choose Payment Method</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            {/* Online Payment Option (Selected) */}
            <div className="border-2 border-blue-500 bg-blue-50/30 rounded-lg p-4 flex items-start gap-3 cursor-pointer">
              <CreditCardIcon className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" />
              <div>
                <div className="font-semibold text-gray-900 text-sm">Online Payment</div>
                <div className="text-xs text-gray-500 mt-0.5">Credit/Debit Card, Netbanking, UPI</div>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-100 rounded-md p-4 flex items-start gap-3 mb-6 flex-1">
            <ShieldAlert className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" />
            <div>
              <p className="text-sm text-blue-800 font-medium mb-1">Secure Payment Gateway</p>
              <p className="text-sm text-blue-700">You will be redirected to our secure payment partner to complete this transaction after you review your payment details in the next step.</p>
            </div>
          </div>

          <div className="mt-8 flex items-center justify-between">
            <Button variant="outline" onClick={onPrevious} className="border-gray-300 text-gray-700">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path></svg> Back
            </Button>
            <Button onClick={onNext} className="bg-blue-600 hover:bg-blue-700 text-white rounded-md px-6">
              Review Payment <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path></svg>
            </Button>
          </div>
        </div>
      </div>

      {/* Right Pane */}
      <div className="lg:col-span-1">
        <OrderSummary allStepData={allStepData} />
        <SafeAndSecure />
      </div>
    </div>
  );
};
